module.exports = __webpack_public_path__ + "static/media/android_small_banner.20884949.jpg";